package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.css.disabled
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.dir
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onFocusOut
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.wordBreak
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.transitionBorder
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.noBorder
import org.jetbrains.compose.web.attributes.DirType
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.CSSUnitLength
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLInputElement

@Composable
fun CustomEditText(
    modifier: Modifier = Modifier,
    helperText:String="",
    initialFocus:Boolean=false,
    fillMaxWidth:Boolean=false,
    width: CSSSizeValue<out CSSUnitLength> = Dimen.semiLargeEditTextWidth,
    height: CSSSizeValue<CSSUnit.px> = Dimen.mediumOutlinedEditTextHeight,
    marginBottom: CSSSizeValue<CSSUnit.px> = Dimen.highLargePadding,
    marginLeft: CSSSizeValue<CSSUnit.px> = 0.px,
    marginRight: CSSSizeValue<CSSUnit.px> = 0.px,
    marginTop: CSSSizeValue<CSSUnit.px> = 0.px,
    startIconSize: Int=Dimen.mediumIconSize,
    endIconSize: Int=Dimen.mediumIconSize,
    label: String = "",
    hasLabelSpace: Boolean = true,
    isEnabled: Boolean = true,
    textAlign: TextAlign = TextAlign.Start,
    value: String,
    isDecimal: Boolean = false,
    usingDotForDigit:Boolean=true,
    endIconPath: String? = null,
    startIconPath:String?=null,
    isRequired: Boolean = true,
    borderless: Boolean = false,
    inputType: InputType<*> = InputType.Text,
    defaultBorderColor: String = Theme.InputEnabledBorder.hex,
    hint: String = "",
    onFocusOutIsActiveWithoutAnyChange:Boolean=false,
    isOutlinedEditText: Boolean = true,
    onFocusIn: () -> Unit,
    onFocusOut: (String) -> Unit,
    onEndIconClick: () -> Unit = {},
    onStartIconClick:()->Unit={},
    onInputChange: (String, MutableState<Boolean>) -> Unit,
    onCloseIconClick:()->Unit={},
    endContent: @Composable ()->Unit ={},
)
{
    val isTextChanged= remember { mutableStateOf(false) }
    val focused = remember { mutableStateOf(initialFocus) }
    val isValid = remember { mutableStateOf(true) }
    val inputValue = remember { mutableStateOf(value) }
    val isHovered = remember{ mutableStateOf(false) }


    LaunchedEffect(key1 = value) {
        inputValue.value = value
    }

    if(isOutlinedEditText){
        Column(
            modifier=Modifier
                .width(width)
                .thenIf(
                    fillMaxWidth,
                    Modifier.fillMaxWidth()
                )
                .margin(
                    bottom =marginBottom,
                    top = marginTop,
                    left = marginLeft,
                    right= marginRight,
                )
        )
        {
            Box(
                modifier = modifier
                    .fillMaxWidth()
                    .height(Dimen.outlinedEditTextParentHeight)
            )
            {
                SpanText(
                    text = label,
                    modifier = Modifier
                        .backgroundColor(Theme.White.rgb)
                        .zIndex(Constants.ZIndex.normalZIndex)
                        .align(Alignment.TopStart)
                        .color(
                            if (focused.value) Theme.PrimaryMain.rgb
                            else if (isHovered.value) Theme.TextSecondary.rgb
                            else if (!isValid.value) Theme.ErrorMain.rgb
                            else  Theme.TextSecondary.rgb
                        )
                        .maxWidth(
                            (width.value.toInt()-4*Dimen.mediumPadding.value.toInt()).px
                        )
                        .fontSize(FontSizes.semiMediumFontSize)
                        .display(DisplayStyle.Block)
                        .wordBreak(WordBreak.BreakAll)
                        .padding(leftRight = Dimen.smallPadding)
                        .margin(leftRight = Dimen.mediumPadding)
                        .fontFamily(FontFamily.Jakarta)
                        .transition(CSSTransition(property = "transform",
                            duration = Constants.editTextTransition))
                        .transition(CSSTransition(property = "opacity",
                            duration = Constants.editTextTransition))
                )

                editTextContent(
                    modifier = Modifier
                        .align(Alignment.BottomStart),
                    focused = focused,
                    focusOutIsActiveWithoutAnyChange=onFocusOutIsActiveWithoutAnyChange,
                    fillMaxWidth =fillMaxWidth,
                    usingDotForDigit =usingDotForDigit,
                    width = width,
                    height = height,
                    borderless = borderless,
                    isEnabled = isEnabled,
                    isValid = isValid,
                    defaultBorderColor = defaultBorderColor,
                    inputType = inputType,
                    onFocusIn = onFocusIn,
                    isRequired = isRequired,
                    inputValue = inputValue,
                    isDecimal =isDecimal,
                    onFocusOut = onFocusOut,
                    onInputChange = onInputChange,
                    hint = hint,
                    startIconSize = startIconSize,
                    endIconSize = endIconSize,
                    endIconPath = endIconPath,
                    onEndIconClick = onEndIconClick,
                    startIconPath = startIconPath,
                    onStartIconClick =onStartIconClick,
                    isHovered = isHovered,
                    textAlign =textAlign,
                    isTextChanged = isTextChanged,
                    endContent = endContent,
                    onCloseSearchBarIconClick = onCloseIconClick
                )


            }

            if (!isValid.value){
                SpanText(
                    text = helperText,
                    modifier=Modifier
                        .fontFamily(FontFamily.Jakarta)
                        .fontSize(FontSizes.normalFontSize)
                        .color(Theme.TextSecondary.rgb)
                        .margin(left = Dimen.extraSmallPadding)
                )
            }
        }



    }
    else{
        Column(
            modifier = modifier
                .margin(bottom =marginBottom)
        )
        {
            if (hasLabelSpace){
                Box(
                    modifier = Modifier
                        .height(Dimen.labelHeight)
                )
            }
            editTextContent(
                focused = focused,
                usingDotForDigit =usingDotForDigit,
                width = width,
                height = height,
                isHovered =isHovered,
                isTextChanged = isTextChanged,
                textAlign =textAlign,
                isDecimal = isDecimal,
                fillMaxWidth = fillMaxWidth,
                borderless = borderless,
                isEnabled = isEnabled,
                isRequired = isRequired,
                hint = hint,
                endIconPath = endIconPath,
                startIconPath = startIconPath,
                startIconSize = startIconSize,
                endIconSize = endIconSize,
                isValid = isValid,
                defaultBorderColor = defaultBorderColor,
                inputType = inputType,
                onFocusIn = onFocusIn,
                onFocusOut = onFocusOut,
                inputValue = inputValue,
                onInputChange = onInputChange,
                onEndIconClick = onEndIconClick,
                onStartIconClick =onStartIconClick,
                onCloseSearchBarIconClick = onCloseIconClick,
                endContent = endContent,
                focusOutIsActiveWithoutAnyChange = onFocusOutIsActiveWithoutAnyChange
            )

            if (!isValid.value){
                SpanText(
                    text = helperText,
                    modifier=Modifier
                        .margin(left = Dimen.extraSmallPadding)
                        .fontFamily(FontFamily.Jakarta)
                        .fontSize(FontSizes.normalFontSize)
                        .color(Theme.TextSecondary.rgb)
                )
            }




        }
    }




}

@Composable
private fun editTextContent(
    modifier: Modifier = Modifier,
    focused: MutableState<Boolean>,
    usingDotForDigit: Boolean,
    width: CSSSizeValue<out CSSUnitLength>,
    height: CSSSizeValue<CSSUnit.px>,
    isHovered: MutableState<Boolean>,
    isTextChanged: MutableState<Boolean>,
    textAlign: TextAlign,
    isDecimal: Boolean,
    focusOutIsActiveWithoutAnyChange: Boolean,
    fillMaxWidth: Boolean,
    borderless: Boolean,
    isEnabled: Boolean,
    isRequired: Boolean,
    hint: String,
    endIconPath: String?,
    startIconPath: String?,
    startIconSize: Int,
    endIconSize: Int,
    isValid: MutableState<Boolean>,
    defaultBorderColor: String,
    inputType: InputType<*>,
    onFocusIn: () -> Unit,
    onFocusOut: (String) -> Unit,
    inputValue: MutableState<String>,
    onInputChange: (String, MutableState<Boolean>) -> Unit,
    onEndIconClick: () -> Unit,
    onStartIconClick: () -> Unit,
    onCloseSearchBarIconClick: () -> Unit,
    endContent: @Composable () -> Unit,
) {
    Row(
        modifier = modifier
            .onMouseOver{ isHovered.value=true }
            .onMouseLeave { isHovered.value=false }
            .width(width)
            .thenIf(
                fillMaxWidth,
                Modifier.fillMaxWidth()
            )
            .height(height)
            .borderRadius(
                r = if (borderless) 0.px
                else Dimen.lowBorderRadius
            )
            .styleModifier {
                property("border-width", if (focused.value)
                    "${Dimen.mediumThickness.value}px"
                else
                    "${Dimen.smallThickness.value}px")
                property("border-style", "solid")
                property("border-color", when {
                    !isEnabled -> Theme.TextDisabled.hex
                    focused.value -> Theme.PrimaryMain.hex
                    isHovered.value -> Theme.TextPrimary.hex
                    !isValid.value -> Theme.ErrorMain.hex
                    else -> defaultBorderColor
                })
                property("box-sizing", "border-box")
            }
            .padding(
                left =
                    if (focused.value)
                        (Dimen.normalPadding.value.toInt()-1).px
                    else Dimen.normalPadding,
                right = if (focused.value)
                        (Dimen.normalPadding.value.toInt()-1).px
                    else Dimen.normalPadding,
            ),
        verticalAlignment = Alignment.CenterVertically
    ) {

        if (startIconPath != null) {
            VectorIcon(
                modifier = Modifier
                .onClick {
                    onStartIconClick()
                },
                pathData = startIconPath,
                width =startIconSize,
                height=startIconSize,
                color =Theme.ActionActive.hex
            )
        }

        Input(
            type = inputType,
            attrs = Modifier
                .transitionBorder()
                .fillMaxSize()
                .color(
                    if(isEnabled) Theme.TextPrimary.rgb
                    else Theme.Tooltip.rgb
                )
                .noBorder()
                .dir(DirType.Ltr)
                .textAlign(textAlign)
                .backgroundColor(Theme.Transparent.rgb)
                .fontWeight(FontWeight.Normal)
                .padding(
                    leftRight = Dimen.smallPadding,
                )
                .fontFamily(FontFamily.Jakarta)
                .fontSize(FontSizes.mediumFontSize)
                .onFocusIn {
                    focused.value = true
                    onFocusIn()
                }
                .onFocusOut {
                    focused.value = false
                    isValid.value = !(isRequired && inputValue.value.isEmpty())

                    if(isValid.value && focusOutIsActiveWithoutAnyChange)
                    {
                        onFocusOut(inputValue.value)
                        isTextChanged.value=false
                    }
                    else if (isValid.value && isTextChanged.value) {
                        onFocusOut(inputValue.value)
                        isTextChanged.value=false
                    }

                }
                .styleModifier {
                    property("::placeholder",
                        "{color: ${Theme.TextDisabled.hex}}")
                }
                .toAttrs {
                    value(inputValue.value)
                    .onInput { event ->
                            val target = event.target as? HTMLInputElement
                            val decimalSeparator = if (usingDotForDigit) '.' else ','

                            val filteredInput = target?.value?.
                            filter { it.isDigit() || it == decimalSeparator }
                                ?.let {
                                    val count = it.count { ch -> ch == decimalSeparator }
                                    if (count > 1) {
                                        val lastIndex = it.lastIndexOf(decimalSeparator)
                                        it.substring(0, lastIndex) +
                                                it.substring(lastIndex + 1)
                                    } else it
                                } ?: ""

                            inputValue.value = if (isDecimal) {
                                filteredInput.ifEmpty { "" }
                            } else {
                                target?.value ?: ""
                            }

                            isTextChanged.value = true
                            onInputChange(inputValue.value, isValid)
                        }
                    //--------------------------------
                    attr("placeholder", hint)
                    if (!isEnabled) {
                        disabled(true)
                    }
                }
        )

        if (inputValue.value.isNotEmpty() && isHovered.value){

            CircleIcon(
                modifier = Modifier
                    .cursor(Cursor.Pointer),
                size = Dimen.normalIconSize,
                img =  Res.PathIcon.mediumClose,
                borderColor = Theme.Transparent.rgb,
                tintColor =Theme.ActionActive.hex ,
                onIconClick = {
                    inputValue.value = ""
                    isTextChanged.value = true
                    onInputChange("", isValid)
                    onCloseSearchBarIconClick()
                },
            )

        }

        if (endIconPath != null) {
            CircleIcon(
                size = endIconSize,
                img = endIconPath,
                borderColor = Theme.Transparent.rgb,
                tintColor =getHexColorCondition(
                    isEnabled = isEnabled,
                    focused = focused.value,
                    isValid = isValid.value,
                    isHovered=isHovered.value,
                ) ,
                onIconClick = {
                    onEndIconClick()
                },
            )

        }

        endContent()

    }
}


private fun getHexColorCondition(
    isEnabled: Boolean,
    focused:  Boolean ,
    isValid: Boolean ,
    isHovered:Boolean,
): String {

    return if (!isEnabled) Theme.TextDisabled.hex
    else {
        if (focused) Theme.PrimaryMain.hex
        else if (isHovered) Theme.TextSecondary.hex
        else {
            if (isValid) Theme.TextSecondary.hex
            else Theme.ErrorMain.hex
        }
    }
}

